var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-loader w-100 h-100 d-flex align-items-center justify-content-center"},[_c('div',[(_vm.manager)?_c('img',{staticClass:"escudo",staticStyle:{"max-height":"150px"},attrs:{"src":_vm.manager.logo}}):_vm._e(),_c('img',{staticClass:"oval",attrs:{"src":"https://storage.compralaentrada.com/images/oval.svg"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }